export default __webpack_public_path__ + "static/media/icons8-offline-100.98f38aea.svg";